import React, { useState } from 'react';
import { DataTable } from 'primereact/datatable';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';

const BaseTable = ({title, createNew, dataList, globalFilterFields, fieldFilters, emptyMessage, cellClassName, isLoading, children, rows, titleExtras}) => {
    const [globalFilter, setGlobalFilter] = useState('');
    const [filters, setFilters] = useState(fieldFilters);
    const reset = () => {
        let _filters = { ...fieldFilters };
        _filters['global'].value = "";

        setFilters(_filters);
        setGlobalFilter('');
    }
    const onGlobalFilterChange = (e) => {
        const value = e.target.value;
        let _filters = { ...filters };
        _filters['global'].value = value;

        setFilters(_filters);
        setGlobalFilter(value);
    }
    const header = (
        <>
            {title && (<div className="table-title"><h3>{title}</h3>{titleExtras}</div>)}
            <div className="table-header">
                <div className="button-panel">
                    {createNew ? <Button type="button" label="New" icon="pi pi-plus" onClick={createNew} /> : <></>}
                    <Button type="button" label="Clear" className="p-button-outlined" icon="pi pi-filter-slash" onClick={reset} />
                </div>
                <span className="p-input-icon-left">
                    <i className="pi pi-search" />
                    <InputText type="search" value={globalFilter} onChange={onGlobalFilterChange} placeholder="Global Search" />
                </span>
            </div>
        </>
    );

    return (
        <div className="mobile-horizontal-scrollable">
            <DataTable value={dataList} paginator
                       dataKey="id"
                       header={header}
                       filterDisplay="row"
                       filters={filters}
                       loading={isLoading}
                       globalFilterFields={globalFilterFields}
                       emptyMessage={emptyMessage}
                       cellClassName={cellClassName}
                       rows={rows || 10}
                       >
                {children}
            </DataTable>
        </div>
    )
}

export default BaseTable;
